import { logWrapper } from '../../utils';
import { UAParser } from 'ua-parser-js';

export default {
  signDocumentsController: [
    'runtimeConstant',
    '$scope',
    '$filter',
    '$location',
    'revisions',
    'sealData',
    'signDocumentService',
    'extensionInstallService',
    function (
      runtimeConstant,
      $scope,
      $filter,
      $location,
      revisions,
      sealData,
      service,
      extensionInstallService
    ) {
      'use strict';

      function legacy_init() {
        if ($scope.debug) window.hwcrypto.debug();

        // Verifica se o plugin está instalado
        if (!window.hwcrypto.use($scope.backend)) {
          $scope.error = 'no_implementation';
          return false;
        }
      }

      function legacy_getCertificate() {
        // Tenta ler o token e obter o certificado
        window.hwcrypto
          .getCertificate({ lang: $scope.lang })
          .then(function (response) {
            $scope.certificate = response;
            $scope.step++;
            $scope.legacy.getHashes();
          })
          .catch(function (error) {
            $scope.error = error.message;
            if ($scope.error === 'user_cancel') $scope.$close(false);
            if ($scope.error === 'no_implementation')
              $scope.error = 'install_legacy';
            $scope.$apply();
          });
      }

      function legacy_getHashes() {
        var docs = [];

        // Cria o objeto para solicitar o hash do arquivo
        for (var i = 0, len = revisions[0].length; i < len; i++) {
          var r = revisions[0][i];
          docs.push(Object.assign({
            id: !r.isHistory ? r.id : r.idRevisionHistory,
            extension: r.extension,
            certificate: $scope.certificate.hex,
            isSigned: r.isSigned === undefined ? false : r.isSigned,
            inFlow: r.IdWorkflow !== undefined && r.IdWorkflow !== null,
            isHistory: r.isHistory,
          }, $scope.sealData ? {
            positionX: $scope.sealData.positionX,
            positionY: $scope.sealData.positionY,
            positionPage: $scope.sealData.positionPage,
            isVisibleSign: $scope.sealData.isVisibleSign,
            logo: $scope.sealData.logo,
            titleSign: $scope.sealData.titleSign,
          } : {}));        }

        // busca o hash dos arquivos a serem assinados
        service
          .getHashes(docs)
          .then(function (response) {
            $scope.documentHashs = response;
            $scope.step++;
            $scope.legacy.signDocuments();
          })
          .catch(function (error) {
            $scope.error = error;
            $scope.$apply();
          });
      }

      function legacy_signDocuments(index) {
        if (index === undefined)
          index = 0;

        var docInfo = $scope.documentHashs[index];

        if ($scope.sealData) {
          docInfo.PositionX = $scope.sealData.positionX;
          docInfo.PositionY = $scope.sealData.positionY;
          docInfo.PositionPage = $scope.sealData.positionPage;
          docInfo.IsVisibleSign = $scope.sealData.isVisibleSign;
          docInfo.Logo = $scope.sealData.logo;
          docInfo.TitleSign = $scope.sealData.titleSign;
        }

        var hash = {
          type: $scope.hashType,
          hex: docInfo.Hash,
        };
        var confs = {
          lang: $scope.lang,
        };
        // Assina os hashes dos documentos
        window.hwcrypto
          .sign($scope.certificate, hash, confs)
          .then(function (response) {
            // Armazena a assinatura
            docInfo.signature = response.hex;

            var r = {};
            r = !docInfo.IsHistory
              ? revisions[0].filter((r) => r.id === docInfo.Id)
              : revisions[0].filter((r) => r.idRevisionHistory === docInfo.Id);

            docInfo.inFlow =
              r.IdWorkflow !== undefined && r.IdWorkflow !== null;

            // Envia a assinatura para WEBAPI juntar tudo e gerar o arquivo final
            service
              .finalizeSignature(docInfo)
              .then(function () {
                //incrementa o indice
                index++;
                docInfo.IsSigned = true;
                // verifica se existe esse indice
                if ($scope.documentHashs.length > index) {
                  //Assina o proximo arquivo
                  $scope.legacy.signDocuments(index);
                } else {
                  $scope.step++;
                  //Atualiza o status das revisões assinadas
                  $scope.updateRevisions();
                }
              })
              .catch(function (error) {
                $scope.error = error;
                $scope.$apply();
              });
          })
          .catch(function (error) {
            $scope.error = error;
            if ($scope.error === 'no_implementation')
              $scope.error = 'install_legacy';
            if (
              $scope.error === 'user_cancel' ||
              $scope.error.message === 'technical_error'
            )
              $scope.$close(false);
            $scope.$apply();
          });
      }

      function signingMessage() {
        var str = String.format(
          $filter('translate')('SIGNING X OF Y DOCUMENTS'),
          [$scope.currentIndex, $scope.totalDocuments]
        );
        return str;
      }

      function signatureProcessMessage() {
        var str = String.format($filter('translate')('RUNNING STEP X OF Y'), [
          $scope.step + 1,
          4,
        ]);
        return str;
      }

      function base64toHEX(base64) {
        var raw = atob(base64);
        var HEX = '';

        for (var i = 0; i < raw.length; i++) {
          var _hex = raw.charCodeAt(i).toString(16);
          HEX += _hex.length === 2 ? _hex : '0' + _hex;
        }
        return HEX.toUpperCase();
      }

      function hexToBase64(str) {
        return btoa(
          String.fromCharCode.apply(
            null,
            str
              .replace(/\r|\n/g, '')
              .replace(/([\da-fA-F]{2}) ?/g, '0x$1 ')
              .replace(/ +$/, '')
              .split(' ')
          )
        );
      }

      function webeid_init() {}

      function webeid_getCertificate() {
        var parser = new UAParser();
        extensionInstallService
          .validateAndInstall(parser)
          .then(function () {
            // Tenta ler o token e obter o certificado
            extensionInstallService
              .getCertificate()
              .then(function (response) {
                $scope.certificate = response;
                $scope.step++;
                $scope.webeid.getHashes();
              })
              .catch(function (error) {
                $scope.error = error.message;
                if ($scope.error === 'user_cancel') $scope.$close(false);
                if ($scope.error === 'no_implementation')
                  $scope.webeid.checkExtension();
                $scope.$apply();
              });
          })
          .catch(function () {
            $scope.error = 'no_implementation';
            $scope.webeid.checkExtension();
          });
      }

      function webeid_getHashes() {
        if (!$scope.certificate) {
          $scope.error = 'no_certificates';
          $scope.$apply();

          return;
        }

        var docs = [];

        // Cria o objeto para solicitar o hash do arquivo
        if (revisions[0].length) {
          for (var i = 0; i < revisions[0].length; i++) {
            var r = revisions[0][i];
            docs.push(Object.assign({
              id: !r.isHistory ? r.id : r.idRevisionHistory,
              extension: r.extension,
              certificate: $scope.base64toHEX($scope.certificate),
              isSigned: r.isSigned === undefined ? false : r.isSigned,
              inFlow: r.IdWorkflow !== undefined && r.IdWorkflow !== null,
              isHistory: r.isHistory,
            }, $scope.sealData ? {
              positionX: $scope.sealData.positionX,
              positionY: $scope.sealData.positionY,
              positionPage: $scope.sealData.positionPage,
              isVisibleSign: $scope.sealData.isVisibleSign,
              logo: $scope.sealData.logo,
              titleSign: $scope.sealData.titleSign,
            } : {}));
          }
        } else {
          var r = revisions[0];
          docs.push(Object.assign({
            id: !r.isHistory ? r.id : r.idRevisionHistory,
            extension: r.extension,
            certificate: $scope.base64toHEX($scope.certificate),
            isSigned: r.isSigned === undefined ? false : r.isSigned,
            inFlow: r.IdWorkflow !== undefined && r.IdWorkflow !== null,
            isHistory: r.isHistory,
          }, $scope.sealData ? {
            positionX: $scope.sealData.positionX,
            positionY: $scope.sealData.positionY,
            positionPage: $scope.sealData.positionPage,
            isVisibleSign: $scope.sealData.isVisibleSign,
            logo: $scope.sealData.logo,
            titleSign: $scope.sealData.titleSign,
          } : {}));
        }

        // busca o hash dos arquivos a serem assinados
        service
          .getHashes(docs)
          .then(function (response) {
            $scope.documentHashs = response;
            $scope.step++;
            $scope.webeid.signDocuments();
          })
          .catch(function (error) {
            $scope.error = error;
            $scope.$apply();
          });
      }

      function webeid_signDocuments(index) {
        if (index === undefined) index = 0;
        var docInfo = $scope.documentHashs[index];
        $scope.totalDocuments = $scope.documentHashs.length;
        $scope.currentIndex = index + 1 + '';

        // Assina os hashes dos documentos
        extensionInstallService
          .sign($scope.certificate, $scope.hexToBase64(docInfo.Hash))
          .then(function (response) {
            // Armazena a assinatura
            docInfo.signature = $scope.base64toHEX(response);

            var r = {};
            if (!docInfo.IsHistory) {
              r = revisions[0].length
                ? revisions[0].filter((r) => r.id === docInfo.Id)
                : (r = revisions[0]);
            } else {
              r = revisions[0].filter(
                (r) => r.idRevisionHistory === docInfo.Id
              );
            }
            docInfo.inFlow =
              r.IdWorkflow !== undefined && r.IdWorkflow !== null;

            // Envia a assinatura para WEBAPI juntar tudo e gerar o arquivo final
            service
              .finalizeSignature(docInfo)
              .then(function () {
                //incrementa o indice
                index++;
                docInfo.IsSigned = true;

                // verifica se existe esse indice
                if ($scope.documentHashs.length > index) {
                  //Assina o proximo arquivo
                  $scope.webeid.signDocuments(index);
                } else {
                  $scope.step++;
                  //Atualiza o status das revisões assinadas
                  $scope.updateRevisions();
                }
              })
              .catch(function (error) {
                $scope.error = error;
                $scope.$apply();
              });
          })
          .catch(function (error) {
            $scope.error = error;
            if ($scope.error === 'no_implementation')
              $scope.webeid.checkExtension();
            if (
              $scope.error === 'user_cancel' ||
              $scope.error.message === 'technical_error' ||
              $scope.error.message === 'invalid_argument'
            ) {
              $scope.$close(false);
            }

            $scope.$apply();
          });
      }

      function webeid_installFirefox() {
        extensionInstallService.firefoxInstall().then(function () {
          $scope.init();
        });
      }

      function webeid_checkExtension() {
        var parser = new UAParser();
        var b = parser.getBrowser();
        extensionInstallService
          .validateAndInstall(parser)
          .then(function () {
            $scope.init();
          })
          .catch(function (err) {
            if (err.error) {
              $scope.downloadInfo = err.downloadInfo;
              $scope.extensionError = err.error;
            } else {
              $scope.extensionError = err;
            }

            $scope.browser = b.name;
            $scope.$applyAsync();
          });
      }

      function updateRevisions() {
        for (var i = 0, len = $scope.documentHashs.length; i < len; i++) {
          var info = $scope.documentHashs[i];
          //busca revisão que foi assinada pra alterar os dados
          var r = revisions[0].length
            ? revisions[0].filter((r) => r.id === info.Id)[0]
            : revisions[0];
          r.isSigned = info.IsSigned;
          // Verifica se alterou a extensão do arquivo
          if (r.isSigned && !r.extension.endsWith('p7s')) {
            r.extension =
              info.Extension === 'pdf' && !info.SignPdfAsP7s
                ? 'pdf'
                : r.extension + '.p7s';
          }
        }
      }

      function selectEngine() {
        var parser = new UAParser();
        var b = parser.getBrowser();

        // verifica se o navegador é o IE
        if (
          navigator.userAgent.indexOf('MSIE') !== -1 ||
          navigator.userAgent.indexOf('Trident') !== -1
        ) {
          $scope.engine = $scope.legacy;
        } else if (
          ['Chrome', 'Firefox', 'Opera', 'Vivaldi'].indexOf(b.name) !== -1
        ) {
          // se não for ie verifica se webeid está instalado
          $scope.engine = $scope.webeid;
        } else {
          // tenta usar o Token Signer
          $scope.engine = $scope.legacy;
        }

        $scope.engine.init();
      }

      function progressWidth() {
        var map = { '-1': '0%', 0: '10%', 1: '33%', 2: '66%', 3: '100%' };

        return map[$scope.step !== undefined ? $scope.step : -1] || '0%';
      };


      function init() {
        $scope.step = -1;
        $scope.error = undefined;
        $scope.extensionError = undefined;

        if ($scope.engine === undefined) $scope.selectEngine();

        $scope.step++;
        $scope.engine.getCertificate();
      }

      function run() {
        try {
          $scope.engine = undefined;
          $scope.legacyUrl =
            'https://installer.id.ee/media/win/Open-EID-21.6.0.1912_x86.exe';
          var url = $location.absUrl();
          $scope.env =
            url.indexOf('localhost') !== -1
              ? 'localhost'
              : url.indexOf('digitaldoc.com.br') !== -1
                ? 'production'
                : 'dev';

          $scope.hashType = 'SHA-1';
          $scope.backend = 'auto';
          $scope.lang = 'en';
          $scope.debug = true;
          $scope.step = -1;
          $scope.certificate = null;
          $scope.documentHashs = null;
          $scope.webeid = {};
          $scope.legacy = {};
          $scope.sealData = sealData || null;

          $scope.messages = [
            { title: 'READING CERTIFICATE', text: 'READING CERTIFICATE MSG' },
            { title: 'GETTING INFO', text: 'GETTING INFO MSG' },
            { title: 'SIGNING', text: 'SIGNING MSG' },
            { title: 'DOCUMENTS SIGNED!', text: 'DOCUMENTS SIGNED! MSG' },
          ];

          $scope.legacy.init = logWrapper(
            legacy_init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.legacy.getCertificate = logWrapper(
            legacy_getCertificate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.legacy.getHashes = logWrapper(
            legacy_getHashes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.legacy.signDocuments = logWrapper(
            legacy_signDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signingMessage = logWrapper(
            signingMessage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.signatureProcessMessage = logWrapper(
            signatureProcessMessage,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.base64toHEX = logWrapper(
            base64toHEX,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.hexToBase64 = logWrapper(
            hexToBase64,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.webeid.init = logWrapper(
            webeid_init,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.webeid.getCertificate = logWrapper(
            webeid_getCertificate,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.webeid.getHashes = logWrapper(
            webeid_getHashes,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.webeid.signDocuments = logWrapper(
            webeid_signDocuments,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.webeid.installFirefox = logWrapper(
            webeid_installFirefox,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.webeid.checkExtension = logWrapper(
            webeid_checkExtension,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.updateRevisions = logWrapper(
            updateRevisions,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.selectEngine = logWrapper(
            selectEngine,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.progressWidth = logWrapper(
            progressWidth,
            runtimeConstant.isDebugControllersInternals
          );
          $scope.init = logWrapper(
            init,
            runtimeConstant.isDebugControllersInternals
          );
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
